import _ from 'lodash';

import { replicationUrnPlatform } from './replications.constants';
import {
  ReplicationBodyFilters,
  ReplicationBodyFiltersPayload,
  ReplicationPlatform,
} from './replications.types';

export const getReplicationDestination = (
  platform: string,
): ReplicationPlatform => {
  return ReplicationPlatform[
    _.upperFirst(platform.split(replicationUrnPlatform)[1])
  ];
};

export const generateReplicationBodyFilters = (
  bodyFilters: ReplicationBodyFilters[],
): ReplicationBodyFiltersPayload => {
  return _.map(bodyFilters, (bodyFilter) => {
    const filteredObject = _.omitBy(bodyFilter, _.isUndefined);
    return _.map(filteredObject, (value, key) => {
      return {
        [key]: value,
      };
    });
  });
};
